import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import { Database } from '@/_constants/database.types';

type PastPaper = Database['public']['Tables']['past_papers']['Row'];

const usePastPaper = (paperId: string | undefined) => {
  return useQuery({
    queryKey: ['past_paper', paperId],
    queryFn: async (): Promise<PastPaper | null> => {
      if (!paperId) return null;

      const { data, error } = await supabaseClient
        .from('past_papers')
        .select('*')
        .eq('id', paperId)
        .single();

      if (error) throw error;

      return data;
    },
    enabled: !!paperId,
  });
};

export default usePastPaper;
